import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const formatDate = (date) => {
  if (!date) return '';
  const d = new Date(date);
  return d.toLocaleDateString('fr-FR', {
    day: 'numeric',
    month: 'long',
    year: 'numeric'
  });
};

export const formatPrice = (price) => {
  return new Intl.NumberFormat('fr-FR').format(price) + ' FCFA';
};

export const slugify = (text) => {
  return text
    .toString()
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/\s+/g, '-')
    .replace(/[^\w-]+/g, '')
    .replace(/--+/g, '-')
    .replace(/^-+/, '')
    .replace(/-+$/, '');
};

export const truncateText = (text, maxLength = 150) => {
  if (!text || text.length <= maxLength) return text;
  return text.substring(0, maxLength).trim() + '...';
};

export const centerColors = {
  diplomante: { bg: '#003366', light: '#E6EEF5' },
  qualifiante: { bg: '#DC143C', light: '#FCE8EC' },
  certifiante: { bg: '#FFD700', light: '#FFF9E6' },
  linguistique: { bg: '#8B5CF6', light: '#F3EFFE' }
};

export const centerNames = {
  diplomante: 'Centre de Formation Diplômante',
  qualifiante: 'Centre de Formation Qualifiante',
  certifiante: 'Centre de Formation Certifiante',
  linguistique: 'Centre de Formation Linguistique'
};
